<template>
  <main class="flex justify-center font-zona">
    <div
      class="w-full min-[1200px]:w-4/5 min-h-[50vh] max-[1200px]:mx-3 py-5 md:py-10 text-sm"
    >
      <img
        src="https://miningmongolia.mn/static/1729577854960.png"
        alt="future engineers"
        class="w-40 object-contain"
      />

      <p class="text-sm text-justify mt-3 tracking-wide">
        {{
          lang === "mn"
            ? "“Монгол Улсын эрдэс баялгийн салбарын боловсон хүчний хэрэгцээ шаардлага болон боломжит олон улсын тэтгэлгийн танилцуулга” цуврал уулзалт."
            : "'Introduction of the personnel needs of Mongolia`s mineral resources sector and possible international scholarships' series of meetings."
        }}
      </p>
      <div v-if="lang === 'mn'">
        <div>
          <p>
            Монголын Уул Уурхайн Үндэсний Ассоциаци (МУУҮА) эрдэс баялгийн
            салбарын ирээдүйн мэргэжилтнүүдийг бэлтгэхэд хувь нэмэр оруулах
            “Ирээдүйн инженер-2030” хөтөлбөрийг 2023 оноос хэрэгжүүлж эхэлсэн.
            Хамрах цар хүрээ, зорилгын хувьд тэлж, Future Engineers буюу
            Ирээдүйн инженер хөтөлбөр үргэлжилж байна.
          </p>
          <h3 class="font-bold mt-4">Future Engineers хөтөлбөрийн зорилго:</h3>
          <div class="">
            <p class="mt-4">
              · Инженер боловсон хүчнийг бэлтгэх, чадавхжуулахад түлхэц үзүүлж,
              энэ мэргэжлийн үнэ цэнийг сурталчлах,
            </p>
            <p>
              · Эрдэс баялгийн салбарын мэргэжилтний хэрэгцээ шаардлага, ач
              холбогдлыг зөвөөр таниулах,
            </p>
            <p>
              · Олон улсад өрсөлдөхүйц инженерүүд төрөн гарах боломж бүрдүүлэх,
            </p>
            <p>
              · Уул уурхайн салбарт шинээр гарч ирж байгаа чухал ашигт малтмал,
              сэргээгдэх эрчим хүч, байгаль орчны чиглэлээр суралцах оюутан
              залуусыг дэмжих,
            </p>
            <p>
              · Инженер мэргэжлээр суралцаж буй оюутан залууст дотоод, гадаадын
              тэтгэлэгт хөтөлбөрт хамрагдах боломжийг өргөн хүрээнд нээж өгөх,
            </p>
            <p>
              · Залуу инженерүүдийн мэргэших, ур чадвараа сайжруулахад дэмжлэг
              үзүүлэх.
            </p>
          </div>
          <h3 class="font-bold mt-4">
            Монгол Улсын эрдэс баялгийн салбарт хамгийн эрэлттэй байгаа ажлын
            байрууд
          </h3>
          <p>/2024 оны 9-р сарын байдлаар/</p>
          <div class="">
            <p>· Хүнд машин механизмын оператор</p>
            <p>· Хүнд машин механизмын засварчин</p>
            <p>· Уул уурхайн инженер, техникийн ажлын байрууд</p>
            <div class="py-4 px-6">
              <p>· Дунд, урт хугацааны төлөвлөлтийн инженер</p>
              <p>· Усны инженер</p>
              <p>· Геологийн инженер</p>
              <p>· Гүний уурхайн агааржуулалтын инженер</p>
            </div>
          </div>
          <h3 class="font-bold">
            Future Engineer/Ирээдүйн инженер хөтөлбөрийн хүрээнд
          </h3>
          <p class="py-4">
            МУУҮА болон Future Engineers хөтөлбөрийн талууд хамтран салбарын
            ажиллах хүчний хэрэгцээ шаардлагад нийцсэн боловсон хүчин бий
            болоход чиглэсэн олон талт арга хэмжээ зохион байгуулан ажилладаг.
            Тухайлбал:
          </p>
          <div class="pb-4">
            <p>
              1. Улаанбаатар хот болон орон нутгийн ЕБС-ийн ахлах ангийн
              сурагчдад инженер мэргэжлийн талаар мэдээлэл өгөх,
            </p>
            <p>
              2. Холбогдох мэргэжлүүдээр суралцаж буй шилдэг оюутнуудад тэтгэлэг
              олгох, цалинтай дадлагажигчийн ажлын байраар хангах,
            </p>
            <p>
              3. Тогтвортой уул уурхайн төлөө (ТУУТ/TSM) стандартыг их дээд
              сургуулийн сургалтын хөтөлбөрт тусгах төсөл хэрэгжүүлэх зэрэг
              ажлуудыг шат дараалан хэрэгжүүлж байна.
            </p>
          </div>
          <h3 class="font-bold mt-4">Хамрах хүрээ:</h3>
          <div>
            <p>· Ерөнхий боловсролын сургуулиудын ахлах ангийн сурагчид</p>
            <p>· Уул уурхай, инженер чиглэлээр суралцагч оюутнууд</p>
            <p>· Мэргэжлээрээ ажиллаж буй залуу инженерүүд</p>
          </div>
          <h3 class="font-bold mt-4">Хамтрагч талууд:</h3>
          <div>
            <p>· Их, дээд сургуулиуд</p>
            <p>·Аж үйлдвэр, эрдэс баялгийн яам</p>
            <p>· Боловсролын яам</p>
            <p>· Аймгуудын ЗДТГ</p>
            <p>· Хот, аймаг, дүүргийн ЕБС</p>
            <p>· Эрдэс баялгийн салбарын компаниуд</p>
            <p>·Хөгжлийн төсөл хөтөлбөрүүд</p>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <p>
            The
            <a class="font-bold">
              Mongolian National Mining Association (MNMA)
            </a>
            launched the
            <a class="font-bold"> Future Engineers-2030 </a> program in 2023 to
            contribute to preparing the next generation of professionals for the
            mineral resources sector. The program has since expanded its scope
            and objectives, continuing today as the
            <a class="font-bold">Future Engineers</a> program.
          </p>
          <h3 class="font-bold mt-4">
            Objectives of the Future Engineers program:
          </h3>
          <div class="">
            <p class="mt-4">
              · Promote the value of engineering professions and support the
              training and capacity-building of engineers.
            </p>
            <p>
              · Raise awareness about the demand and importance of professionals
              in the mineral resources sector.
            </p>
            <p>
              · Enable the development of internationally competitive engineers.
            </p>
            <p>
              · Support students pursuing studies in critical minerals,
              renewable energy, and environmental disciplines emerging in the
              mining sector.
            </p>
            <p>
              · Broaden access to domestic and international scholarship
              programs for students studying engineering.
            </p>
            <p>
              · Assist young engineers in acquiring expertise and improving
              their professional skills.
            </p>
          </div>
          <h3 class="font-bold mt-4">
            Most in-demand jobs in Mongolia’s mineral resources sector (as of
            September 2024):
          </h3>

          <div class="">
            <p>· Heavy equipment operators</p>
            <p>· Heavy equipment mechanics</p>
            <p>·Mining engineering and technical positions</p>
            <div class="py-4 px-6">
              <p>· Medium- and long-term planning engineers</p>
              <p>· Water resource engineers</p>
              <p>· Geological engineers</p>
              <p>· Underground mine ventilation engineers</p>
            </div>
          </div>
          <h3 class="font-bold">
            Key activities under the Future Engineers program:
          </h3>
          <p class="py-4">
            In collaboration with MNMA and the program’s partners, a variety of
            initiatives are implemented to prepare a workforce that meets the
            needs of the sector:
          </p>
          <div class="pb-4">
            <p>
              1️⃣ Provide information about engineering careers to high school
              students in Ulaanbaatar and rural areas.
            </p>
            <p>
              2️⃣ Award scholarships to outstanding university students in
              relevant fields and offer them paid internship opportunities.
            </p>
            <p>
              3️⃣ Implement projects to integrate the Towards Sustainable Mining
              (TSM) standard into higher education curricula.
            </p>
          </div>
          <h3 class="font-bold mt-4">Target audiences:</h3>
          <div>
            <p>· High school students (senior grades)</p>
            <p>· University students in mining and engineering fields</p>
            <p>· Young engineers currently working in the sector</p>
          </div>
          <h3 class="font-bold mt-4">Partner organizations:</h3>
          <div>
            <p>· Universities and colleges</p>
            <p>· Ministry of Industry and Mineral Resources</p>
            <p>· Ministry of Education</p>
            <p>· Provincial and local governments</p>
            <p>· Secondary schools in cities, provinces, and districts</p>
            <p>· Companies in the mineral resources sector</p>
            <p>· Development projects and programs</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "FutureMiners",
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    return { lang };
  },
};
</script>
